module.exports = __webpack_public_path__ + "gce.logo.cfe8f.png";